<div class="cart-group-metadata">
  <a
    [class]="{
      'cart-group-metadata__link': true,
      'cart-group-metadata__link--full-width': !!courthouseFullWidth(),
    }"
    [routerLink]="courthousePath()"
  >
    <svg ftrIcon="Courthouse" [iconSize]="18"></svg>
    <span>{{ group().courthouse.name }}</span>
  </a>
  <a class="cart-group-metadata__link" [routerLink]="courtroomPath()">
    <svg ftrIcon="Courtroom" [iconSize]="18"></svg>
    <span>{{ group().courtroom.name }}</span>
  </a>
  <a class="cart-group-metadata__link" [routerLink]="datePath()" [queryParams]="dateQueryParam()">
    <svg ftrIcon="CalendarDay" [iconSize]="18"></svg>
    <ftr-date [date]="group().recordingDate" [format]="dateFormat" />
  </a>
</div>
